import { useData } from "./DataContext.js";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

import ImpactIcons from "./ImpactIcons.js";
import ImpactBar from "./ImpactBar.js";
import VariableTitle from "./VariableTitle.js";
import InvestmentBar from "./InvestmentBar.js";

export default function ImpactList (props)
{
    const gData = useData();

    const variableItems = Object.entries(gData.content.variables).map(([id, variable]) => {
	const popover = (
	    <Popover className="p-2 bg-light text-dark border-dark shadow text-center px-3" style={{ width: "240px" }}>
		<div className="fw-medium"><VariableTitle variableId={variable.id}/></div>
		<div>{variable.description}</div>
	    </Popover>
	);
	
	return (
	    <OverlayTrigger key={variable.id} placement="left" overlay={popover}>
	    {({ ref, ...triggerHandler }) => (
		<div className="d-flex justify-content-start align-items-center gap-2" {...triggerHandler}>
		    <span className="fs-4" ref={ref}><VariableTitle variableId={variable.id} icon="only"/></span>
		    
		    {props.type === "analysis" && (<ImpactIcons variableId={variable.id} solutionId={props.solutionId}/>)}
		    {props.type === "impact" && (<ImpactBar variableId={variable.id} solutionId={props.solutionId} type={"impact"}/>)}
		    {props.type === "state" && (<ImpactBar variableId={variable.id} type={"state"}/>)}
		    {props.type === "result" && (<ImpactBar variableId={variable.id} type={"result"}/>)}
		    {props.type === "inter-result" && (<ImpactBar variableId={variable.id} type={"inter-result"}/>)}
		</div>
	    )}
	</OverlayTrigger>
	);
    });
    
    const popover = (
	<Popover className="p-2 bg-light text-dark border-dark shadow text-center px-3" style={{ width: "240px" }}>
	    <div className="fw-medium"><VariableTitle variableId={"investment"}/></div>
	    <div>Budget disponible pour des achats de long terme</div>
	</Popover>
    );
    
    const investmentItem = (
	<OverlayTrigger placement="left" overlay={popover}>
	    {({ ref, ...triggerHandler }) => (
		<div className="d-flex justify-content-start align-items-center gap-2" {...triggerHandler}>
		    <span className="fs-4" ref={ref}><VariableTitle variableId={"investment"} icon={"only"}/></span>
		    {props.type === "analysis" && (<InvestmentBar solutionId={props.solutionId} type={"analysis"}/>)}
		    {props.type === "impact" && (<InvestmentBar solutionId={props.solutionId} type={"impact"}/>)}
		    {props.type === "state" && (<InvestmentBar type={"state"}/>)}
		    {props.type === "result" && (<InvestmentBar type={"result"}/>)}
		    {props.type === "inter-result" && (<InvestmentBar type={"inter-result"}/>)}
		</div>
	    )}
	</OverlayTrigger>
    );
    
    return (
	<div>
	    <div className="d-flex flex-column gap-1">
		{variableItems}
		{investmentItem}
	    </div>
	</div>
    );
}
